import React, { useEffect, useState } from 'react'

import { toast } from 'react-toastify'
import { useGetMintedData } from '../../hooks/useGetMintedData'
import { mint } from '../../hooks/useMint'
import { converToWei } from '../../utility/helpers'
import styles from './MintingInfo.module.scss'
import Popup from 'reactjs-popup';
import './Popup.scss'


const Web3 = require('web3');

export const MintingInfo = () => {
    const [success, setSuccess] = useState(true);
    const [open, setOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("No Error")
    const openModal = (msg) => {
        setErrorMsg(msg);
        setOpen(true);
    }
    const closeModal = () => setOpen(false);

    const [mintingCount, setMintingCount] = useState(1)
    const [blockNumber, setBlockNumber] = useState(0)

    const [
        getStep,
        getMintingPrice,
        getMintingLimit,
        getMintingIdx,
        getMintingStartBlock,
        getMintingMax,
        getAirdropCount,
        isWhiteList,
        updateMintedData,
        updateWhiteList,
        loading
    ] = useGetMintedData()
    
    useEffect(() => {
        try {
            if (!window.ethereum) throw new Error("No crypto wallet found")

            updateWhiteList(window.ethereum.selectedAddress);
        } catch (error) {
            console.log(error);
            return;
        }

        const web3 = new Web3(window.ethereum);
        const blockUpdateTimer = setInterval(() => web3.eth.getBlockNumber().then(setBlockNumber), 2000);
        const mintDataUpdateTimer = setInterval(() => {

            updateWhiteList(window.ethereum.selectedAddress);
            updateMintedData();
        }, 5000);
        return () => {
            clearInterval(blockUpdateTimer);
            clearInterval(mintDataUpdateTimer);
        };
    }, [updateMintedData,
        updateWhiteList]);

    function plusCount() {
        if (mintingCount < 20) {
            setMintingCount(mintingCount + 1);
        }
    }

    function minusCount() {
        if (mintingCount > 1) {
            setMintingCount(mintingCount - 1);
        }
    }

    async function minting() {
        const options = {
            autoClose: 5000,
            hideProgressBar: false,
            position: toast.POSITION.TOP_CENTER,
            pauseOnHover: true,
        };

        if (!window.ethereum) {
            toast.error("No crypto wallet found", options);
            return;
        }

        if (blockNumber == 0 || loading) {
            toast.warn("Connecting to the blockchain", options);
            return;
        }

        if (blockNumber < getMintingStartBlock()) {
            toast.warn("Not started", options);
            return;
        }

        if (!isWhiteList()) {
            toast.warn("You are not whitelisted", options);
            return;
        }

        if (getMintingIdx() > getMintingLimit()) {
            toast.warn("Sold out", options);
            return;
        }

        mint(converToWei(getMintingPrice().toString()), mintingCount, setSuccess, openModal);
    }

    return (
        <div className={styles.minting_info_container}>
            <div className={styles.info_block}>
                <div className={styles.info_title}>
                    Contents
                </div>
                <div className={styles.info_contents}>
                    {!window.ethereum || loading ? 'Loading' : getStep()}
                </div>
            </div>
            <div className={styles.info_block}>
                <div className={styles.info_title}>
                    Minting Starts
                </div>
                <div className={styles.info_contents}>
                    {!window.ethereum || loading ? 'Loading' : getMintingStartBlock()}
                </div>
            </div>
            <div className={styles.info_block}>
                <div className={styles.info_title}>
                    Ticket Price
                </div>
                <div className={styles.info_contents}>
                    {!window.ethereum || loading ? 'Loading' : getMintingPrice()} MATIC
                </div>
            </div>
            <div className={styles.info_block}>
                <div className={styles.info_title}>
                    PASS Left
                </div>
                <div className={styles.info_contents}>
                    {!window.ethereum || loading ? 'Loading' : getMintingMax() - getMintingIdx()}
                </div>
            </div>
            <div className={styles.info_block}>
                <div className={styles.info_title}>
                    Per Transaction
                </div>
                <div className={styles.info_contents}>
                    Maximum 20 Tickets
                </div>
            </div>
            <div className={styles.info_block}>
                <div className={styles.info_title}>
                    Per Wallet
                </div>
                <div className={styles.info_contents}>
                    Unlimited
                </div>
            </div>
            <div className={styles.progress_block}>
                <div className={styles.progress_num_block}>
                    <div className={styles.progress_num_text}>{getMintingMax() - getAirdropCount()}</div>
                    <div className={styles.progress_num_text}>{(getMintingMax() - getAirdropCount()) / 2}</div>
                    <div className={styles.progress_num_text}>0</div>
                </div>
                <progress className={styles.progress_bar} value={getMintingIdx() - getAirdropCount()} max={getMintingMax() - getAirdropCount()}></progress>
            </div>
            <div className={styles.control_container}>
                <div className={styles.amount_block}>
                    Amount
                </div>
                <div className={styles.control_block}>
                    <button className={styles.minus_btn} onClick={minusCount}></button>
                    <div className={styles.count_block}>
                        {mintingCount}
                    </div>
                    <button className={styles.plus_btn} onClick={plusCount}></button>
                </div>
                <button className={styles.button_block} onClick={minting}>
                    Get Ticket
                </button>

                <Popup open={open} closeOnDocumentClick onClose={closeModal}>
                    <div className={styles.popup_block}>
                        {success ? 
                            <div className={styles.popup_contents_block}>
                                <div className={styles.popup_icon_success}>

                                </div>
                                <div className={styles.popup_title}>
                                    Congratulation
                                </div>
                                <div className={styles.popup_contents}>
                                    Minting Success!
                                </div>
                            </div>
                            :
                            <div className={styles.popup_contents_block}>
                                <div className={styles.popup_icon_failed}>

                                </div>
                                <div className={styles.popup_title}>
                                    So sad...
                                </div>
                                <div className={styles.popup_contents}>
                                    {errorMsg}
                                </div>
                            </div>
                        }
                        <div className={styles.close_popup} onClick={closeModal}>
                            Close
                        </div>
                    </div>
                </Popup>
            </div>
        </div>
    )
}